export function formatNumber (num: number | string) {
  return new Intl.NumberFormat('en-US').format(parseFloat(num.toString()))
}

export function preventNonNumericInput (event: KeyboardEvent) {
  const { key } = event
  if (key && !(key.match(/^[0-9]/) || key === 'Enter')) {
    event.preventDefault()
  }
}
